

export default function SmallArrow({
  className
}: { className?: string }) {
  return (
    <svg width="100%" height="100%" className={className} viewBox="0 0 13 13" fill="#F2F2F2" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.24957 2.6269L8.81024 2.6269L0.209961 11.2272L1.77864 12.7959L10.6358 3.93867V10.0224H12.8543V0.77885L11.5688 0.77885V0.408447H3.24957L3.24957 2.6269Z" />
    </svg>
  )
}
